<script lang="ts">
	interface Props {
		height?: string; // Default height
		width?: string; // Default width
		class?: string;
	}

	let { height = '48px', width = '48px', class: className = '' }: Props = $props();
	
</script>

<svg
	{height}
	{width}
	class={className}
	viewBox="0 0 24 24"
	fill="none"
	xmlns="http://www.w3.org/2000/svg"
>
	<path
		d="M23.737 3.161C23.68 2.82256 23.4546 2.53645 23.1389 2.40187C22.8232 2.26729 22.4606 2.30276 22.177 2.496C19.8766 3.8993 17.2073 4.57837 14.516 4.445C8.337 4.445 5.758 6.964 5.709 7.022C2.73537 9.21388 1.63359 13.1474 3.036 16.565C3.11071 16.7472 3.07157 16.9562 2.936 17.099L0.268002 19.988C-0.0890452 20.3747 -0.0880909 20.9711 0.270192 21.3566C0.628474 21.7422 1.22322 21.7868 1.635 21.459C3.351 19.9 6.15 15.2 14.019 11.911C14.5308 11.7022 15.1152 11.9449 15.3285 12.4548C15.5418 12.9648 15.3041 13.5513 14.796 13.769C11.6544 15.0546 8.79142 16.9362 6.365 19.31L6.356 19.32L6.124 19.571C6.0206 19.6802 5.97184 19.8301 5.99123 19.9793C6.01062 20.1284 6.09611 20.2609 6.224 20.34C7.50128 21.1406 8.97856 21.5645 10.486 21.563C12.5147 21.5273 14.5026 20.9867 16.27 19.99V19.99C25.039 15.166 24.2 5.889 23.737 3.161Z"
		fill="currentColor"
	/>
</svg>
